import { MprcConfirmDialog, MprcRequestIndicator } from "components";
import { MprcRequestSnackbarErrorReport } from "components/MprcRequestErrorReport";
import { useCoreApi } from "providers/CoreApiProvider";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";

////////////////////////////////////////////////////////////////////////////////

interface IProps {
    deployId: string;
    title: string;
    onClose: (reload?: boolean) => void;
}

export const AssDeployDeclineDialog = ({ deployId, title, onClose }: IProps) => {
    const api = useCoreApi();
    const { t } = useTranslation("assessment");
    const [posting, setPosting] = useState<boolean>(false);

    const doDecline = () => {
        setPosting(true);
        api.v1.assDeploy.declineAdHocSurvey({ deployId })
            .then(() => onClose(true))
            .catch(e => {
                MprcRequestSnackbarErrorReport(e);
                onClose(false);
            })
            .finally(() => setPosting(false));
    };

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <>
            <MprcRequestIndicator type="post" visible={posting} />

            <MprcConfirmDialog
                open
                message={<Trans t={t} i18nKey={"AssDeploy.DeclineDialog.Message"} values={{ name: title }} />}
                onClose={
                    (confirm) => {
                        if (confirm) doDecline();
                        else onClose();
                    }
                }
            />
        </>
    );
};
